import React, { useEffect, useCallback, useState } from 'react';
import { Icon, Spin } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import Widget from 'components/Widget';
import TableWithLoadMore from 'components/TableWithLoadMore';
import FormFilter from './FormFilter';
import Columns from './Columns';
import { fetchCrisis, loadMoreCrisis } from 'appRedux/actions/Crisis';
import { fetchRole } from 'appRedux/actions/Role';
import { fetchCategory } from 'appRedux/actions/Category';
import convertData from 'firebase/utils/convertData';

const ListingCrisis = ({ crisisList, roleList, categoryList, loading, isShowMore, fetchCrisis, fetchRole, fetchCategory, loadMoreCrisis, loadingRole, loadingCategory, currentUser }) => {
  const [toggle, setToggle] = useState(false);
  const [filterValues, setFilterValues] = useState({});
  const lastDoc = isEmpty(crisisList) ? null : crisisList[crisisList.length - 1];
  const convertedData = isEmpty(crisisList) ? [] : convertData(crisisList);
  const categories = isEmpty(categoryList) ? [] : convertData(categoryList);
  const role = localStorage.getItem('role');
  const isAdmin = role === 'admin';
  const isLineManager = role === 'line-manager';
  const isMember = !isLineManager && !isAdmin;
  let roles = isEmpty(roleList) ? [] : convertData(roleList, true, true);
  roles = isLineManager ? roles.filter(role => role.line_manager === currentUser || role.email === currentUser) : roles;

  const handleFetchData = useCallback(
    (filter = null) => {
      if (currentUser) {
        if (isAdmin) {
          setFilterValues(filter);
          fetchCrisis({
            filter,
          });
          return;
        }
        if (isMember) {
          const filterParams = filter ? { ...filter, created_by: currentUser } : { created_by: currentUser };
          setFilterValues(filterParams);
          fetchCrisis({
            filter: filterParams,
          });
        }
      }
    },
    [currentUser, fetchCrisis, isAdmin, isMember]
  );

  const handleFetchDataForLineManager = useCallback(
    (filter = null) => {
      if (currentUser) {
        const members = isEmpty(roles) ? [] : roles.map(role => role.email);
        const filterParams = filter ? { ...filter, created_by: filter.created_by || [currentUser, ...members] } : { created_by: [currentUser, ...members] };
        setFilterValues(filterParams);
        fetchCrisis({
          filter: filterParams,
        });
      }
    },
    [currentUser, fetchCrisis, roles]
  );

  const handleloadMoreData = (lastDoc = null) => {
    loadMoreCrisis({
      lastDoc,
      filter: filterValues,
    });
  };

  const handleToggle = () => {
    setToggle(!toggle);
  };

  useEffect(
    () => {
      fetchRole();
      fetchCategory();
      handleFetchData();
    },
    [fetchCategory, fetchRole, handleFetchData]
  );

  useEffect(() => {
    if (isLineManager && !loadingRole && isEmpty(crisisList) && currentUser) {
      const members = roles.map(role => role.email);
      const filterParams = { created_by: [currentUser, ...members] };
      setFilterValues(filterParams);
      fetchCrisis({
        filter: filterParams,
      });
    }
  }, [crisisList, currentUser, fetchCrisis, isLineManager, loadingRole, roles]);

  return (
    <Spin spinning={!currentUser} tip="Đang tải dữ liệu...">
      <Widget
        styleName="gx-order-history"
        title={<h2 className="h4 gx-text-capitalize gx-mb-0">Search by Crisis</h2>}
        extra={
          <p onClick={handleToggle} className="gx-text-primary gx-mb-0 gx-pointer">
            {toggle ? (
              <>
                <Icon type="up-circle" /> Đóng tìm kiếm
              </>
            ) : (
              <>
                <Icon type="search" /> Bạn cần tìm kiếm dữ liệu ?
              </>
            )}
          </p>
        }
      >
        {toggle && <FormFilter loadingCategory={loadingCategory} categories={categories} isMember={isMember} roles={roles} onSearch={filter => isLineManager ? handleFetchDataForLineManager(filter) : handleFetchData(filter)} />}
        <TableWithLoadMore
          rowClassName={(r, i) => {
            return i !== 0 ? 'first-row' : '';
          }}
          className="table-crisis"
          rowKey={r => `${r.created_at}_${r.index}`}
          columns={Columns()}
          data={convertedData}
          loading={loading}
          isShowMore={isShowMore}
          onLoadMore={() => handleloadMoreData(lastDoc)}
          numRows={crisisList.length}
        />
      </Widget>
    </Spin>
  );
};

const mapStateToProps = ({ crisis, auth, role, category }) => {
  const { data: crisisList = [], loading, isShowMore } = crisis;
  const { data: roleList = [], loading: loadingRole } = role;
  const { data: categoryList = [], loading: loadingCategory } = category;
  const { currentUser } = auth;
  return { crisisList, roleList, loading, isShowMore, currentUser, categoryList, loadingCategory, loadingRole };
};

export default connect(
  mapStateToProps,
  { fetchCrisis, loadMoreCrisis, fetchRole, fetchCategory }
)(ListingCrisis);
